export default "__VITE_ASSET__BFLMrXl$__"